import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, NavLink } from 'react-router-dom';
import Slider from 'react-slick';
import Div100vh from 'react-div-100vh';
import ReactScrollWheelHandler from 'react-scroll-wheel-handler';

//redux import
import { fetchHome } from '../requests/home_request';

//components
import Header from '../components/Header';
import Loader from '../components/Loader';

//assets
import ConsultBanner from '../images/banner/Freeconsult.svg';

class Homepage extends Component {
    state = {
        currentIndex: 0,
        firstActive: false,
        latest: false,
        oldIndex: 0,
        newIndex: 0,
    };

    nextClick = this.nextClick.bind(this);
    nextSlide = this.nextSlide.bind(this);
    updateBG = this.updateBG.bind(this);

    componentDidMount() {
        let body = document.body;

        body && body.classList.add('is-homepage');

        // fetch content from homepagina located in WP.
        this.showSlideContent(this.props, true);
        this.nextClick(this.state.currentIndex);

        if (this.state.currentIndex === 0) {
            this.setState({
                firstActive: true,
            });
        }
    }

    componentWillUnmount() {
        let body = document.body;

        body && body.classList.remove('is-homepage');
    }

    componentDidUpdate() {
        let body = document.body;
        let home = document.querySelector('.home');

        if (!home) {
            body && body.classList.remove('is-homepage');
        } else {
            body && body.classList.add('is-homepage');
        }
    }

    updateBG(value, index) {
        let home = document.querySelector('.home');

        if (home) {
            if (this.state.currentIndex === index) {
                home.style.backgroundColor = value.project_colorpicker;
                document.title = `Friends Agency - ${value.project_titel}`;
            }
        }
    }

    nextClick(e, current) {
        this.setState({
            currentIndex: e,
            firstActive: false,
        });

        if (this.state.currentIndex === 0) {
            this.setState({
                firstActive: true,
            });
        } else {
            this.setState({
                firstActive: false,
            });
        }
    }
    nextSlide() {
        this.slider.slickNext();
    }

    showSlideContent(willMount = false) {
        if (willMount) {
            this.props.fetchHome();
        }
    }

    initSlider() {
        // rest api fetch data
        const slideData =
            this.props.home.fetched &&
            this.props.home.content[0].acf.slider_extends;

        return slideData.map((value, index) => (
            <div
                ref={this.slides}
                className={`home__slide slick-slide-${index}`}
                key={index}
                onChange={this.updateBG(value, index)}
                style={{
                    backgroundColor: value.project_colorpicker,
                }}>
                <div className="fader">
                    <div className="home__inner">
                        <div className="row">
                            <div className="home__content-area col-sm-9">
                                <h1 className="home__title">
                                    <span className="home__innertitle">
                                        {value.project_titel}
                                    </span>
                                </h1>
                                <p className="home__text">
                                    <span className="home__innertext">
                                        {value.project_intro}
                                    </span>
                                </p>
                                <div className="home__cta cta-container">
                                    {index === 0 ? (
                                        <div className="cta-container">
                                            <NavLink
                                                to={Homepage.getRelativeUrl(
                                                    value.project_link
                                                )}
                                                className="cta-btn white">
                                                How we work
                                            </NavLink>
                                            <Link
                                                className="cta-btn white"
                                                to="/people">
                                                Meet the team
                                            </Link>
                                            <div className="home__consultbanner">
                                                <Link to="/online-consult">
                                                    <img
                                                        src={ConsultBanner}
                                                        alt="plan an consult"
                                                    />
                                                </Link>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="cta-container">
                                            <NavLink
                                                to={Homepage.getRelativeUrl(
                                                    value.project_link
                                                )}
                                                className="cta-btn black">
                                                View case
                                            </NavLink>
                                            <Link
                                                className="cta-btn black"
                                                to="/work">
                                                Our best cases
                                            </Link>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="home__image-container col-sm-offset-0 col-sm-12 col-md-offset-3 col-md-8 col-lg-offset-4 col-lg-8 no-padding">
                                <div className="imgcontainer">
                                    <div
                                        className="imgcontainer__overlay"
                                        style={{
                                            backgroundColor:
                                                value.project_colorpicker,
                                        }}
                                    />
                                    {value.project_image && (
                                        <img
                                            onMouseDown={(e) => {
                                                e.preventDefault();
                                            }}
                                            className="img-responsive"
                                            src={
                                                value.project_image.sizes
                                                    .slider_img_sm
                                            }
                                            alt={value.project_titel}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        ));
    }

    static getRelativeUrl(url) {
        if (url === window.location.origin) {
            return '/';
        }
        return url.substr(window.location.origin.length);
    }

    setCurrentSlideIndex = (oldIndex, newIndex) => {
        this.setState({
            oldIndex: oldIndex,
            newIndex: newIndex,
        });
    };

    slickSlides() {
        const settings = {
            dots: true,
            arrows: false,
            autoplay: false,
            infinite: true,
            draggable: false,
            speed: 100,
            touchThreshold: 500,
            vertical: true,
            verticalSwiping: true,
            slidesToShow: 1,
            slidesToScroll: 1,

            beforeChange: (oldIndex, newIndex) => {
                this.setState({
                    oldIndex: oldIndex,
                    newIndex: newIndex,
                    currentIndex: newIndex,
                });

                this.setCurrentSlideIndex(oldIndex, newIndex);
            },
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        draggable: true,
                        touchThreshold: 200,
                        infinite: true,
                        dots: false,
                        mobileFirst: true,
                    },
                },
            ],
        };

        return (
            <Slider ref={(slider) => (this.slider = slider)} {...settings}>
                {this.initSlider()}
            </Slider>
        );
    }

    prevIndex = () => {
        const { currentIndex } = this.state;
        if (currentIndex >= 0) {
            return this.slider.slickPrev();
        }
    };

    nextIndex = () => {
        const { currentIndex } = this.state;
        if (currentIndex <= this.slider.props.children.length) {
            return this.slider.slickNext();
        }
    };

    render() {
        return (
            <div
                className={`home ${this.state.currentIndex === 0 && 'slide-0'}`}
                onLoad={this.slideInit}>
                <Div100vh>
                    <div className="home__topcontainer">
                        <Header />
                    </div>
                    <div className="mouse">
                        {this.state.latest ? (
                            ''
                        ) : (
                            <div>
                                <span
                                    className={`mouse-scrolltext ${
                                        this.state.currentIndex === 0
                                            ? 'active'
                                            : ''
                                    }`}
                                    onClick={this.nextSlide}>
                                    more projects below
                                </span>
                                <div className="mouse-icon">
                                    <span className="mouse-wheel" />
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="hand">
                        <span className="hand-swiper" />
                    </div>

                    <main>
                        <ReactScrollWheelHandler
                            upHandler={() => this.prevIndex()}
                            downHandler={() => this.nextIndex()}>
                            {this.props.home.fetched && this.slickSlides()}
                        </ReactScrollWheelHandler>
                        <Loader
                            loaded={
                                this.props.home.fetched ||
                                this.props.home.failed
                            }
                        />
                    </main>
                </Div100vh>
            </div>
        );
    }
}

function mapStateToProps({ home }) {
    return { home };
}

const mapDispatchToProps = {
    fetchHome,
};

export default connect(mapStateToProps, mapDispatchToProps)(Homepage);



// WEBPACK FOOTER //
// ./src/containers/Homepage.jsx